var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { staticClass: "tree-left", attrs: { span: 4 } }, [
                _c(
                  "div",
                  { staticClass: "tree-box-content" },
                  [
                    _c("div", { staticClass: "text" }, [_vm._v("协议类型")]),
                    _vm._v(" "),
                    _c("el-tree", {
                      ref: "tree",
                      staticClass: "blue-theme",
                      attrs: {
                        data: _vm.treeData,
                        "show-checkbox": false,
                        "node-key": "id",
                        "default-expand-all": true,
                        "highlight-current": true,
                        "check-on-click-node": false,
                        "current-node-key": _vm.currentNodeKey,
                        "icon-class": "el-icon-arrow-right",
                        "expand-on-click-node": false,
                        props: _vm.defaultProps,
                      },
                      on: { "node-click": _vm.handleClick },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var node = ref.node
                            var data = ref.data
                            return _c(
                              "div",
                              { staticClass: "custom-tree-node" },
                              [
                                _c("span", { staticClass: "flex-box" }, [
                                  _vm._v(_vm._s(node.label)),
                                ]),
                              ]
                            )
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "right", attrs: { span: 20 } },
                [
                  _c(
                    "div",
                    { staticClass: "btn-box" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["setting:agreement:save"],
                              expression: "['setting:agreement:save']",
                            },
                          ],
                          attrs: {
                            type: "primary",
                            loading: _vm.loadding,
                            size: "small",
                          },
                          on: { click: _vm.saveCurrent },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "mt20" },
                    [
                      _c("ueditorFrom", {
                        ref: "ueditorFrom",
                        attrs: {
                          border: true,
                          height: _vm.height,
                          content: _vm.content,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }